export default "__VITE_ASSET__DG2BGxw2__"